import { useStaticQuery, useStaticMutation } from '../../../helpers/useStaticData';
import { getFoodOrders } from '../../../helpers/data';

export const useGetOrderQuery = () => useStaticQuery(() => getFoodOrders());

export const useAddOrderMutation = () => useStaticMutation();

export const useUpdateOrderMutation = () => useStaticMutation();

export const useDeleteOrderMutation = () => useStaticMutation();
